export default "__VITE_ASSET__DiefHx4y__"